import { useState } from "react";

const TrashIcon = ({
  color = "#2B363B",
  hoverColor = "#db0b27",
  width = 24,
  height = 24,
  opacity = 1,
  strokeWidth = 1.66667,
  ...props
}) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Icono eliminar"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{ cursor: "pointer", ...props.style }}
      {...props}
    >
      <path
        d="M1.33331 4.83333H14.6666M6.33331 8.16667V13.1667M9.66665 8.16667V13.1667M2.16665 4.83333L2.99998 14.8333C2.99998 15.2754 3.17557 15.6993 3.48813 16.0118C3.8007 16.3244 4.22462 16.5 4.66665 16.5H11.3333C11.7753 16.5 12.1993 16.3244 12.5118 16.0118C12.8244 15.6993 13 15.2754 13 14.8333L13.8333 4.83333M5.49998 4.83333V2.33333C5.49998 2.11232 5.58778 1.90036 5.74406 1.74408C5.90034 1.5878 6.1123 1.5 6.33331 1.5H9.66665C9.88766 1.5 10.0996 1.5878 10.2559 1.74408C10.4122 1.90036 10.5 2.11232 10.5 2.33333V4.83333"
        stroke={isHover ? hoverColor : color}
        strokeOpacity={opacity}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashIcon;
